import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './ResourceWorkOrders.css';
import { WorkOrderStatusEnum } from 'services/utils/work-order-status-enum';
import NavigationBar from 'components/shared/navigation/NavigationBar';
import WorkOrdersTable from 'components/shared/table/WorkOrdersTable';
import { goToWorkOrder } from 'actions/admin/work-orders/work-orders';

class ResourceWorkOrders extends Component {
  static propTypes = {
    resource: PropTypes.shape({}),
    workOrders: PropTypes.shape({}),
    currentPage: PropTypes.number.isRequired,
    loadWorkOrdersRequest: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    // Keep track of id to avoid showing an "old" resource while loading the current one
    this.currentNav = 1;
  }

  componentDidMount() {
    const { resource, loadWorkOrdersRequest } = this.props;
    if (resource !== null) {
      this.props.dispatch(loadWorkOrdersRequest(resource.id, 1));
    }
  }

  handleWorkOrderSelection = (index) => {
    this.props.dispatch(goToWorkOrder(this.props.workOrders.content[index].id));
  };

  handleNavSelect = (value) => {
    this.currentNav = value;
    this.handleChange(1);
  };

  handlePageChange = (newPage) => {
    this.handleChange(newPage);
  };

  handleChange(page) {
    const { dispatch, resource, loadWorkOrdersRequest } = this.props;
    switch (this.currentNav) {
      case 1:
        dispatch(loadWorkOrdersRequest(resource.id, page));
        break;

      case 2:
        dispatch(loadWorkOrdersRequest(resource.id, page, undefined, true));
        break;

      case 3:
        dispatch(
          loadWorkOrdersRequest(resource.id, page, WorkOrderStatusEnum.DRAFT)
        );
        break;

      case 4:
        dispatch(
          loadWorkOrdersRequest(resource.id, page, WorkOrderStatusEnum.PENDING)
        );
        break;

      case 5:
        dispatch(
          loadWorkOrdersRequest(resource.id, page, WorkOrderStatusEnum.PLM)
        );
        break;

      case 6:
        dispatch(
          loadWorkOrdersRequest(resource.id, page, WorkOrderStatusEnum.WOA)
        );
        break;

      case 7:
        dispatch(
          loadWorkOrdersRequest(
            resource.id,
            page,
            WorkOrderStatusEnum.IN_PROGRESS
          )
        );
        break;

      case 8:
        dispatch(
          loadWorkOrdersRequest(resource.id, page, WorkOrderStatusEnum.COMPLETE)
        );
        break;

      case 9:
        dispatch(
          loadWorkOrdersRequest(resource.id, page, WorkOrderStatusEnum.CLOSED)
        );
        break;

      case 10:
        dispatch(
          loadWorkOrdersRequest(resource.id, page, WorkOrderStatusEnum.DECLINED)
        );
        break;

      default:
    }
  }

  render() {
    const { resource, currentPage, workOrders } = this.props;
    if (resource !== null && workOrders !== null) {
      return (
        <div className="resource-work-orders">
          <NavigationBar
            items={[
              {
                id: 1,
                title: 'All',
              },
              {
                id: 2,
                show: workOrders.totalCritical > 0,
                title: 'Critical',
                total: workOrders.totalCritical,
              },
              {
                id: 3,
                show: workOrders.totalDraft > 0,
                title: 'Draft',
                total: workOrders.totalDraft,
              },
              {
                id: 4,
                show: workOrders.totalPending > 0,
                title: 'Pending',
                total: workOrders.totalPending,
              },
              {
                id: 5,
                show: workOrders.totalPlm > 0,
                title: 'PLM',
                total: workOrders.totalPlm,
              },
              {
                id: 6,
                show: workOrders.totalWoa > 0,
                title: 'WOA',
                total: workOrders.totalWoa,
              },
              {
                id: 7,
                show: workOrders.totalInProgress > 0,
                title: 'In Progress',
                total: workOrders.totalInProgress,
              },
              {
                id: 8,
                show: workOrders.totalComplete > 0,
                title: 'Complete',
                total: workOrders.totalComplete,
              },
              {
                id: 9,
                show: workOrders.totalClosed > 0,
                title: 'Closed',
                total: workOrders.totalClosed,
              },
              {
                id: 10,
                show: workOrders.totalDeclined > 0,
                title: 'Declined',
                total: workOrders.totalDeclined,
              },
            ]}
            onSelected={this.handleNavSelect}
          />

          <WorkOrdersTable
            currentPage={currentPage}
            pageSize={workOrders.pageSize}
            showFilter={false}
            totals={{
              all: workOrders.total,
            }}
            total={workOrders.total}
            workOrders={workOrders.content}
            onPageChange={this.handlePageChange}
            onWorkOrderSelection={this.handleWorkOrderSelection}
          />
        </div>
      );
    }
    return null;
  }
}

export default connect()(ResourceWorkOrders);



// WEBPACK FOOTER //
// ./src/components/shared/work-orders/ResourceWorkOrders.js